import { EVENT_PAYLOAD, IMPRESSION_PAYLOAD, } from '#pplx/frontend/framework/instrumentation/types.js';
export const checkoutModalNavigationSelectedEvent = EVENT_PAYLOAD;
export const proCheckoutStartedEvent = EVENT_PAYLOAD;
export const proCheckoutAttemptEvent = EVENT_PAYLOAD;
export const proCheckoutErrorEvent = EVENT_PAYLOAD;
export const proCheckoutSuccessEvent = EVENT_PAYLOAD;
// Emitted via both `track()` and `impression()`; typed as an impression
// factory since its result satisfies both call shapes.
export const pricingModalViewedEvent = IMPRESSION_PAYLOAD;
export const subscriptionPromotionViewedEvent = {
    event: 'subscription promotion viewed',
    data: {},
};
export const subscriptionPromotionButtonClickedEvent = {
    event: 'subscription promotion button clicked',
    data: {},
};
//# sourceMappingURL=analytics.js.map